/**
 * Sharing helpers for business owners: promote the shop / a product to their
 * customers on WhatsApp.
 *
 * The links always point at the customer web app (https://app.carata.co) using
 * the business handle / product slug - the same links link-preview crawlers
 * (WhatsApp included) turn into a rich card, and that open the customer app on
 * a phone that has it installed. IDs are only a fallback for records that
 * don't have a handle / slug yet.
 */
export const SHARE_ORIGIN = "https://app.carata.co";

const SAFE_KEY = /^[A-Za-z0-9._-]+$/;
// Static words the customer app/API reserve under /business and /products.
const RESERVED_KEYS = ["search", "create", "bookmarked", "check-availability"];

function shareKey(primary, fallback) {
    const key = String(primary ?? "").trim();

    if (key && SAFE_KEY.test(key) && !RESERVED_KEYS.includes(key.toLowerCase())) {
        return key;
    }

    return fallback ?? null;
}

export function businessShareUrl(company) {
    const key = shareKey(company?.handle, company?.id);
    return key ? `${SHARE_ORIGIN}/business/${encodeURIComponent(key)}` : null;
}

export function productShareUrl(product) {
    const key = shareKey(product?.slug, product?.id);
    return key ? `${SHARE_ORIGIN}/products/${encodeURIComponent(key)}` : null;
}

/** https://wa.me/?text=... opens WhatsApp's "choose a chat" screen with the text ready. */
export function whatsappShareHref(text) {
    return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function businessWhatsappHref(company) {
    const url = businessShareUrl(company);
    return url ? whatsappShareHref(`Order from us on Carata:\n${url}`) : null;
}

export function productWhatsappHref(product) {
    const url = productShareUrl(product);
    if (!url || !product?.name) return null;

    return whatsappShareHref(`Order ${product.name} from us on Carata:\n${url}`);
}
